import React from 'react'

/** @type {import("./types").default} */
const Html = ({ Component = 'span', children, className, ...props }) => (
  <Component {...props} className={className} dangerouslySetInnerHTML={{ __html: children }} />
)

export default Html
